import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://weld-en.impultienda.ar/checkout/';
type Props = {
  label?: string;
  sub?: string;
  size?: 'md' | 'lg';
  id?: string;
};
export function CTAButton({
  label = 'I WANT THE WELD DECISION SYSTEM',
  sub = 'ONE-TIME PAYMENT · INSTANT ACCESS',
  size = 'lg',
  id
}: Props) {
  return <div id={id} className="w-full" data-id="element-25" data-mp="2g1xzgbxl3nkh">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-xl bg-flame-500 text-center font-display font-extrabold uppercase tracking-wide text-ink-900 shadow-[0_10px_0_0_#B13B02] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-flame-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-spark active:translate-y-[6px] active:shadow-[0_4px_0_0_#B13B02] ${size === 'lg' ? 'px-5 py-4 text-xl leading-6 sm:text-2xl' : 'px-4 py-3 text-lg leading-5'}`} data-id="element-26" data-mp="2tykw0dlmkbpv">
        <span data-id="element-27" data-mp="19aptmvbruefr">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="1dai4jeon0woa" />
      </a>
      {sub ? <p className="mt-2.5 text-center text-[11px] font-semibold uppercase tracking-[0.14em] text-zinc-400 sm:text-xs" data-id="element-29" data-mp="1n8o4hqqvvsqi">
          {sub}
        </p> : null}
    </div>;
}